<template>

  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="bank_payment_is_load" parent="bank_payment">
    <tab id="info" :name="translate('bank_payment.section.info')" :href="url+'/info'">
      <BankPaymentInfo v-if="bank_payment_is_load"
        :bank_payment="bank_payment_info"
        @update="get_bank_payment"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              Bank Payment: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/bank_payment_list'}">
              To Bank Payment list
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import BankPaymentInfo from './Tabs/Info/Index.vue'

export default {
  name: 'BankPayment',
  components: {
    BankPaymentInfo,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'info',
      bank_payment_info: null,
    }
  },

  computed: {
    url () { return '/bank_payment/' + this.$route.params.bank_payment_id },
    cur_id () { return this.$route.params.bank_payment_id },
    load () { return !this.bank_payment_info?.id },
    bank_payment_is_load() { return this.bank_payment_info !== null }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'bank_payment_section') {
        this.get_bank_payment()
      }
    }
  },

  activated(){
    this.get_bank_payment()
  },

  methods: {
    get_bank_payment () {
      this.$http.v1.getBankPayment(this.$route.params.bank_payment_id, (response) => {
        this.bank_payment_info = response.data
      })
    }
  }
}

</script>
